import "./index.css";

import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import {
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Table,
  Nav,
  NavItem,
  Input,
  Button
} from "reactstrap";
import { useSearchParams } from "react-router-dom";

import dateHelper from "helpers/dateHelper";
import brokerRequests from "requests/brokerRequests";
import ReportLogRequest from "requests/reportLogRequest";

const ShipmentDetails = () => {
  const [urlParameters] = useSearchParams();
  const [shipment, setShipment] = useState({});

  const timken_ids = ["7204", "13790"];

  const TABS = {
    ATTRIBUTES: "ATTRIBUTES",
    EVENTS: "EVENTS",
    COSTS: "COSTS",
  };

  const INTEGRATIONS = {
    COMETRIX: 'COMETRIX',
    TRANSVOYANT: 'TRANSVOYANT',
    REPORTLOG: 'REPORTLOG'
  }

  const [activeTab, setActiveTab] = useState(TABS.ATTRIBUTES);
  const [activeIntegration, setActiveIntegration] = useState(INTEGRATIONS.TRANSVOYANT);

  useEffect(() => {
    const shipmentId = urlParameters.get("shipment_id");
    loadShipment(shipmentId)

  }, []);

  const loadShipment = (shipmentId) => {
    toast
      .promise(brokerRequests.getShipment(shipmentId), {
        loading: "Carregando processo",
        success: "Sucesso",
        error: "Não foi possível carregar o processo",
      })
      .then((data) => {
        setShipment(data);
      });
  }

  const getTabProps = (tab) => {
    return {
      className: isTabActive(tab) ? "active-tab" : "",
      onClick: (e) => setActiveTab(tab),
    };
  };

  const isTabActive = (tab) => {
    return activeTab === tab;
  };

  const isIntegrationActive = (integration) => {
    return activeIntegration === integration;
  };

  const currencyFormat = (value, currency) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: currency,
    }).format(value);

  const reSend = (data) => {
    console.log('reSend' , data)
    
    toast.promise(ReportLogRequest.reSendData(data), {
      loading: "Reenviando...",
      success: "Sucesso",
      error: "Erro"
    })
    .then((response) => {
      const shipmentId = urlParameters.get("shipment_id");
      loadShipment(shipmentId);
    });
  }

  const downloadJson = (shipment) => {

    toast.promise(brokerRequests.downloadJson(shipment?.IDPROCESSO), {
      loading: "Baixando arquivo...",
      success: "Sucesso",
      error: "Não foi possível baixar o arquivo"
    })
    .then((response) => {
      if (response.data.error){
        toast.error(response.data.error)
        return;
      }

      const jsonData = response.data;
      const jsonString = JSON.stringify(jsonData, null, 2);


      const now = Date();
      const formattedDate = dateHelper.formatDateWithHours(now);
      const fileBlob = new Blob([jsonString], { type: 'application/json' });

      saveAs(fileBlob, `${shipment?.NRPROCESSO}_${formattedDate}.json`);
      
    });
  }


  return (
    <div className="card-container">
      <div className="details-container full-height">
        <Card>
          <CardHeader>{shipment?.NRPROCESSO}</CardHeader>
          <CardBody>
            <ListGroup flush>
              <ListGroupItem>
                <div className="shipment-data">
                  <b>ID Broker</b>
                  <p>{shipment?.IDPROCESSO}</p>
                </div>

                <div className="shipment-data">
                  <b>Referência Auxiliar</b>
                  <p>{shipment?.NRREFAUXILIAR}</p>
                </div>

                <div className="shipment-data">
                  <b>Modal</b>
                  <p>{shipment?.viatransporte?.NMVIATRANSPORTE}</p>
                </div>

                <div className="shipment-data">
                  <b>Abertura</b>
                  <p>{shipment?.DTABERTURA}</p>
                </div>
              </ListGroupItem>

              <ListGroupItem>
                <div className="shipment-data">
                  <b>House</b>
                  <p>{shipment?.NRCONHECIMENTO}</p>
                </div>

                <div className="shipment-data">
                  <b>Master</b>
                  <p>{shipment?.NRCONHECMASTER}</p>
                </div>

                <div className="shipment-data">
                  <b>Pol (Port of Landing)</b>
                  <p>{shipment?.local_embarque?.NMTERMINALCARGA}</p>
                </div>

                <div className="shipment-data">
                  <b>Pod (Port of Discharge)</b>
                  <p>{shipment?.local_desembarque?.NMTERMINALCARGA}</p>
                </div>
              </ListGroupItem>

              <ListGroupItem>
                {/* traducao */}
                <div className="shipment-data">
                  {/* <b>Portador</b> */}
                  <b>Carrier</b>
                  <p>{shipment?.transporte_internacional?.NMPESSOA}</p>
                </div>

                <div className="shipment-data">
                  <b>Container</b>
                  <p>{shipment?.container?.NRCONTAINER}</p>
                </div>

                <div className="shipment-data">
                  <b>Container Type</b>
                  <p>{shipment?.container?.tipo_container?.NMTIPOCONTAINER}</p>
                </div>

                <div className="shipment-data">
                  <b>Embarcação</b>
                  <p>{shipment?.embarcacao?.NMEMBARCACAO}</p>
                </div>

                <div className="shipment-data">
                  <b>Viagem</b>
                  <p>{shipment?.NRNUMEROVIAGEM}</p>
                </div>
              </ListGroupItem>
              <ListGroupItem>
                <div className="shipment-data">
                  <b>Código do Cliente</b>
                  <p>{shipment?.cliente?.CDPESSOA}</p>
                </div>

                <div className="shipment-data">
                  <b>Nome do Cliente</b>
                  <p>{shipment?.cliente?.APPESSOA}</p>
                </div>

                <div className="shipment-data">
                  <b>CPF/CNPJ</b>
                  <p>
                    {shipment?.cliente?.CNPJ
                      ? shipment?.cliente?.CNPJ
                      : shipment?.cliente?.CPF}
                  </p>
                </div>
                {shipment?.IDPESSOACLIENTE == "10286" &&
                <div className="shipment-data">
                  <b>Baixar JSON Cometrix</b>
                  <Button
                    style={{
                    width: "5rem",
                    height: "50%",
                  }}
                  color="primary"
                  onClick={() => downloadJson(shipment)}>
                    <p>Download</p>
                  </Button>
                </div>
                
                }

                {timken_ids.includes(shipment?.IDPESSOACLIENTE) &&
                  <div className="shipment-data">
                    <b>Baixar JSON Report Log</b>
                    <Button
                      style={{
                        width: "5rem",
                        height: "50%",
                      }}
                      color="primary"
                      onClick={() => downloadJson(shipment)}>
                      <p>Download</p>
                    </Button>
                  </div>
                }

              </ListGroupItem>
            </ListGroup>
            {/*shipmentHistory?.length > 0 && 
                                <ListGroup>
                                    <ListGroupItemHeading>Histórico de envio</ListGroupItemHeading>
                                        {shipmentHistory?.map((history, index) => (
                                            <div className="history-container" key={index}>
                                                {history.map((shipment, index) => (
                                                    <p key={index}>
                                                        {shipment?.key === 'created_at' || shipment?.key === 'updated_at' 
                                                            ? `${shipment?.key}: ${dateHelper.formatDateWithHours(shipment?.value).toString()}`
                                                            : `${shipment?.key}: ${shipment?.value}`
                                                        }
                                                    </p>
                                                ))}
                                            </div>    
                                        ))}
                                </ListGroup>
                            */}
            <h3>Histórico de Integração</h3>
            <Input type="select" onChange={e => setActiveIntegration(e.target.value)}>
              <option value={INTEGRATIONS.COMETRIX} selected={isIntegrationActive(INTEGRATIONS.COMETRIX)}>Cometrix</option>
              <option value={INTEGRATIONS.TRANSVOYANT} selected={isIntegrationActive(INTEGRATIONS.TRANSVOYANT)}>TransVoyant</option>
              <option value={INTEGRATIONS.REPORTLOG} selected={isIntegrationActive(INTEGRATIONS.REPORTLOG)}>Report Log</option>
            </Input>
            <Nav tabs>              
              <NavItem {...getTabProps(TABS.ATTRIBUTES)}>Atributos</NavItem>
              <NavItem {...getTabProps(TABS.EVENTS)}>Eventos</NavItem>
              <NavItem {...getTabProps(TABS.COSTS)}>Custos</NavItem>
            </Nav>
            {isTabActive(TABS.ATTRIBUTES) && <>

              {isIntegrationActive(INTEGRATIONS.TRANSVOYANT) && <Table hover responsive striped size="sm" className="okok">
                {/* traducao */}
                <thead>
                  <tr>
                    <th>Data</th>
                    {/* <th>Portador</th>*/}
                    <th>Carrier</th>
                    {/* <th>Referência</th>*/}
                    <th>Reference</th>
                    <th>Master</th>
                    <th>House</th>
                    <th>POD</th>
                    <th>POL</th>
                  </tr>
                </thead>
                <tbody>
                  {shipment?.atributos_integrados_transvoyant?.map((data) => (
                    <tr>
                      <td>{data.created_at}</td>
                      <td>{data.carrier}</td>
                      <td>{data.customerReferenceNumber}</td>
                      <td>{data.mawb}</td>
                      <td>{data.houseAwb}</td>
                      <td>{data.pod}</td>
                      <td>{data.pol}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>}
            </>}

            {isTabActive(TABS.EVENTS) && <>
              {isIntegrationActive(INTEGRATIONS.TRANSVOYANT) && <Table hover responsive striped size="sm">
                <thead>
                  <tr>
                    <th>Data da Integração</th>
                    <th>Código</th>
                    <th>Descrição</th>
                    <th>Data do Evento</th>
                  </tr>
                </thead>
                <tbody>
                  {shipment?.eventos_integrados_transvoyant?.map((data) => (
                    <tr>
                      <td>{data.created_at}</td>
                      <td>{data.code}</td>
                      <td>{data.description}</td>
                      <td>{data.event_date}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>}
            </>}
            {/* traducao */}
            {isTabActive(TABS.COSTS) && <>

                {isIntegrationActive(INTEGRATIONS.TRANSVOYANT) && 
                <Table hover responsive striped size="sm">
                  <thead>
                    <tr>
                      <th>Data da Integração</th>
                      {/* <th>Chave do Envio</th> */}
                      <th>Shipment Key</th>
                      {/* <th>Atual</th> */}
                      <th>Currency</th>
                      {/* <th>Custo Padrão</th> */}
                      <th>Standard Cost</th>
                      {/* <th>Custo Adicional</th> */}
                      <th>Additional Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shipment?.custos_integrados_transvoyant?.map((data) => (
                      <tr>
                        <td>{data.created_at}</td>
                        <td>{data.shipmentKey}</td>
                        <td>{data.currency}</td>
                        <td>
                          {currencyFormat(data.standardCosts, data.currency)}
                        </td>
                        <td>
                          {currencyFormat(data.additionalCosts, data.currency)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>}

                {isIntegrationActive(INTEGRATIONS.COMETRIX) && <Table hover responsive striped size="sm">
                  <thead>
                    <tr>
                      <th>Data da Integração</th>
                      <th>Tipo</th>
                      <th>Parametros</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shipment?.custos_integrados_cometrix?.map((i) => (
                      <tr>
                        <td>{i.created_at}</td>
                        <td>{i.type}</td>
                        <td>
                          <ul>
                            {Object.keys(i.data).map(k => {
                              return <li><b>{k}:</b> {i.data[k]?.toString()}</li>
                            })}
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>}
                
                {isIntegrationActive(INTEGRATIONS.REPORTLOG) && 
                <Table hover responsive striped size="sm">
                  <thead>
                    <tr>
                      <th>Data da Integração</th>
                      <th>Tipo</th>
                      <th>Parametros</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shipment?.receipts_report_log?.map((i) => (
                      <tr>
                        <td>
                          <span>{i.created_at}</span><br />
                          <Button onClick={() => reSend(i)}>Forçar Reenvio</Button>
                        </td>
                        <td>Recibo</td>
                        <td>
                          <ul>    
                            {Object.keys(i.data).map(k => {
                              if (k != "itens"){
                                return <li><b>{k}:</b>{Object.keys(i.data[k]).map(key => {
                                  return <li><b>{key}:</b> {i.data[k][key]?.toString()}</li>
                                })}
                                </li>
                              } else {
                                return <li><b>Itens:</b>{i.data["itens"].map(item => {
                                  return <li>{item.descricao} - <b>moeda:</b> {item.moeda} <b>valor_moeda:</b> {item.valor_moeda} -- <b>valor_reais: </b>{item.valor_reais}</li>
                                  })
                                }
                                </li>
                              }

                            })} 
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                
                }

              </>}
          </CardBody>
        </Card>

        <Card style={{ overflow: "hidden" }}>
          <CardHeader>Follow Up</CardHeader>
          <CardBody>
            <Table hover responsive striped size="sm">
              <thead>
                <tr style={{ textTransform: "capitalize" }}>
                  <th>Ord.</th>
                  <th>Evento</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {shipment?.followup?.map((followup) => (
                  <tr>
                    <td>{followup.NRORDEM}</td>
                    <td>
                      {followup.evento?.NMEVENTO} ({followup.IDEVENTO})
                    </td>
                    <td>{followup.DTREALIZACAO}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ShipmentDetails;
